/*函数节流*/
export function throttle(fn, interval) {
  var enterTime = 0;//触发的时间
  var gapTime = interval || 300 ;//间隔时间，如果interval不传，则默认300ms
  return function() {
    var context = this;
    var backTime = new Date();//第一次函数return即触发的时间
    if (backTime - enterTime > gapTime) {
      fn.call(context,arguments);
      enterTime = backTime;//赋值给第一次触发的时间，这样就保存了第二次触发的时间
    }
  };
}

/*函数防抖*/
export function debounce(fn, interval) {
  var timer;
  var gapTime = interval || 200;//间隔时间，如果interval不传，则默认1000ms
  return function() {
    clearTimeout(timer);
    var context = this;
    var args = arguments;//保存此处的arguments，因为setTimeout是全局的，arguments不是防抖函数需要的。
    timer = setTimeout(function() {
      fn.call(context,args);
    }, gapTime);
  };
}
export function GetRandomNum(Min,Max){
	var Range = Max - Min;
	var Rand = Math.random();
	return(Min + Math.round(Rand * Range));
}
export function accAdd(arg1,arg2){
     var r1,r2,m;
     try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0};
     try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0};
     m=Math.pow(10,Math.max(r1,r2));
     return (arg1*m+arg2*m)/m;
}
export function accSub(arg1,arg2){
    var r1,r2,m,n;
    try{r1=arg1.toString().split(".")[1].length;}catch(e){r1=0;}
    try{r2=arg2.toString().split(".")[1].length;}catch(e){r2=0;}
    m=Math.pow(10,Math.max(r1,r2));
    //动态控制精度长度
    n=(r1>=r2)?r1:r2;
    return ((arg1*m-arg2*m)/m).toFixed(n);
}
export function accMul(arg1,arg2)
{
    var m=0,s1=arg1.toString(),s2=arg2.toString();
      try{m+=s1.split(".")[1].length}catch(e){};
      try{m+=s2.split(".")[1].length}catch(e){};
      return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m);
}
export function accDiv(arg1,arg2){
    var t1=0,t2=0,r1,r2;
    try{t1=arg1.toString().split(".")[1].length;}catch(e){}
    try{t2=arg2.toString().split(".")[1].length;}catch(e){}
	Math.r1=Number(arg1.toString().replace(".",""));
	Math.r2=Number(arg2.toString().replace(".",""));
	return (Math.r1/Math.r2)*Math.pow(10,t2-t1);
}
export function getFloat(number, n) {
	n = n ? parseInt(n) : 0;
	if(n <= 0) {
		return Math.round(number);
	}
	number = Math.round(number * Math.pow(10, n)) / Math.pow(10, n); //四舍五入
	number = Number(number).toFixed(n); //补足位数
	return number;
};

export function parseQuery() {
  const res = {};

  const query = (location.href.split("?")[1] || "")
    .trim()
    .replace(/^(\?|#|&)/, "");

  if (!query) {
    return res;
  }

  query.split("&").forEach(param => {
    const parts = param.replace(/\+/g, " ").split("=");
    const key = decodeURIComponent(parts.shift());
    const val = parts.length > 0 ? decodeURIComponent(parts.join("=")) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res;
};

export function inArray(arr,str) {
	for(var i=0;i<arr.length;i++){
		if(arr[i]==str){
			return true;
		}
	}
	return false;
}

export function evaluatePasswordStrength(password) {
    let score = 0;

    // 长度得分
    if (password.length >= 6) score++;
    if (password.length >= 12) score++;

    // 大小写字母得分
    if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score++;

    // 数字得分
    if (/\d/.test(password)) score++;

    // 特殊字符得分
    if (/[\W_]/.test(password)) score++;

    // 根据得分评估密码强度
    if (score <= 1) {
        return 1;
    } else if (score === 2) {
        return 2;
    } else if (score === 3) {
        return 3;
    } else {
        return 4;
    }
}

// 金额千分位加逗号
export function amountRule(amount){
  let defaultAmount = ' '
  let setAmount = amount + ' '
  if(setAmount != 'null' && setAmount != '' && setAmount != 'undefined' && setAmount != '--'){
    defaultAmount = Number(setAmount).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    return defaultAmount
  }else{
    return  defaultAmount
  }
}

export function isMobile() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // iOS detection
  if (/iPhone|iPad|iPod/.test(userAgent) && !window.MSStream) {
    return true;
  }

  // Android detection
  if (/android/i.test(userAgent)) {
    return true;
  }

  // Windows Phone detection
  if (/windows phone/i.test(userAgent)) {
    return true;
  }

  // Other mobile detection
  if (/Mobile|Android|Silk|Kindle|BlackBerry|Opera Mini|Opera Mobi|webOS|IEMobile|Windows CE|MQQBrowser|Polaris|UCBrowser|NokiaBrowser/i.test(userAgent)) {
    return true;
  }

  // If no match, assume it's a desktop
  return false;
}

export function timeToDateTime(timestamp) {
  // 创建日期对象
  let date = new Date(timestamp);

  // 获取年份、月份、日期、小时、分钟和秒数
  let year = date.getFullYear();
  let month = (date.getMonth() + 1).toString().padStart(2, '0');
  let day = date.getDate().toString().padStart(2, '0');
  let hours = date.getHours().toString().padStart(2, '0');
  let minutes = date.getMinutes().toString().padStart(2, '0');
  let seconds = date.getSeconds().toString().padStart(2, '0');

  // 拼接成 yyyy-MM-dd HH:mm:ss 格式
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function tampToTime(timestamp) {
  const now = new Date();
  now.setHours(0, 0, 0, 0); // 将当前时间设置为今天的0点0分0秒
  const _timestamp = now.getTime(); // 获取时间戳（毫秒）
  if(timestamp<_timestamp){
       return timeToDateTime(timestamp);
  }
  // 创建日期对象
  let date = new Date(timestamp);
  // 获取年份、月份、日期、小时、分钟和秒数
  let hours = date.getHours().toString().padStart(2, '0');
  let minutes = date.getMinutes().toString().padStart(2, '0');
  let seconds = date.getSeconds().toString().padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
}



export function getlhInfos(ball, t) {
    ball = parseInt(ball);

    const ball_wuxing = {
        "金":[3,4,11,12,25,26,33,34,41,42],
		"木":[7,8,15,16,23,24,37,38,45,46],
		"水":[13,14,21,22,29,30,43,44],
		"火":[1,2,9,10,17,18,31,32,39,40,47,48],
		"土":[5,6,19,20,27,28,35,36,49]
    };

    const ball_color = [
        [1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46],
        [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48],
        [5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49]
    ];

    const ball_color_name = ['rgb(231, 22, 7)', 'rgb(35, 137, 233)', 'rgb(31, 182, 29)'];
    const ball_color_key = [1, 2, 3];

    const ball_xiao = [
        [2, 14, 26, 38], [3, 15, 27, 39], [4, 16, 28, 40], [5, 17, 29, 41],
        [6, 18, 30, 42], [7, 19, 31, 43], [8, 20, 32, 44], [9, 21, 33, 45], [10, 22, 34, 46],
        [11, 23, 35, 47], [12, 24, 36, 48],[1, 13, 25, 37, 49]
    ];

    const ball_xiao_name = ["龙", "兔", "虎", "牛", "鼠", "猪", "狗", "鸡", "猴", "羊", "马", "蛇"];

    if (t === 4) {
        for (let i = 0; i < ball_color.length; i++) {
            if (ball_color[i].includes(ball)) {
                return ball_color_key[i];
            }
        }
    }
    if (t === 1) {
        for (let i = 0; i < ball_color.length; i++) {
            if (ball_color[i].includes(ball)) {
                return ball_color_name[i];
            }
        }
    }
    if (t === 2) {
        for (const [key, val] of Object.entries(ball_wuxing)) {
            if (val.includes(ball)) {
                return key;
            }
        }
    }
    if (t === 3) {
        for (let i = 0; i < ball_xiao.length; i++) {
            if (ball_xiao[i].includes(ball)) {
                return ball_xiao_name[i];
            }
        }
    }
    if (t === 5) {
        return ball % 2 === 0 ? '双' : '单';
    }
    if (t === 6) {
        return ball < 25 ? '小' : '大';
    }
    return '--';
}


export function getbjl(cai_id, num){
	    	const _decimals = parseFloat(num).toString().split('.');
			const decimalss = _decimals.length==2?_decimals[1]+'0':'00';
			const decimals = decimalss.slice(0, 2);
	    	const digits = decimals.padStart(2, '0').split('').map(Number);
			if(cai_id==12){
				const ball = digits[0] + digits[1];
				const _ball = ball%10;
				return _ball<10?'0'+_ball:_ball;
			}else if(cai_id==13){
				const _ball = digits[1];
				return _ball<10?'0'+_ball:_ball;
			}else if(cai_id==14){
				const ball = parseInt(digits[0]) * 10 + parseInt(digits[1]);
				if(ball<50){
					return ball<10?'0'+ball:ball;
				}else{
					const _ball = ball - 50;
					return _ball<10?'0'+_ball:_ball;
				}
			}else{
			    const ball = parseInt(digits[0]) * 10 + parseInt(digits[1]);
			    if(ball>50){
					const _ball = 100 - ball;
			    	return _ball<10?'0'+_ball:_ball;
			    }else{
			    	return ball==50?0:(ball<10?'0'+ball:ball);
			    }
			}
}



// WEBPACK FOOTER //
// ./src/api/util.js